import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from '@ui-elements/Button';
import { ButtonProps } from '@mui/material/Button';
import { PALETTE } from '~/assets/styles/base';

const StyledButton = styled(Button)`
  margin: 0 5px;
  width: 120px;
  height: 32px;
  border: 2px solid ${PALETTE.primary.main};
  background: ${PALETTE.white};
`;

type ToolProps = {
  variant: ButtonProps['variant'];
  // eslint-disable-next-line @typescript-eslint/ban-types
  func: Function;
  label: string;
};

type Props = {
  tools: ToolProps[];
};

const ToolButtons: React.FC<Props & ButtonProps> = ({ tools }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div data-testid="uiParts-ToolButtons">
      {tools.map((tool) => (
        <StyledButton key={tool.label} variant={tool.variant} handleClick={() => tool.func()}>
          {t(tool.label)}
        </StyledButton>
      ))}
    </div>
  );
};
export default ToolButtons;
